export type InputAction = 'left' | 'right' | 'jump' | 'shoot' | 'restart' | 'fly' | 'spawn' | 'escape' | 'tab';

// используем e.code — физическая клавиша, не зависит от раскладки
const CODE_MAP: Record<string, InputAction> = {
  ArrowLeft: 'left', KeyA: 'left',
  ArrowRight: 'right', KeyD: 'right',
  ArrowUp: 'jump', KeyW: 'jump', Space: 'jump',
  KeyJ: 'shoot', KeyZ: 'shoot',
  // Демо-сборка: читы T (болванчик), F (полёт) и быстрый рестарт R скрыты от игрока.
  // KeyR: 'restart',
  // KeyF: 'fly',
  // KeyT: 'spawn',
  Escape: 'escape',
  Tab: 'tab',
};

export class Input {
  private down = new Set<InputAction>();
  private pressed = new Set<InputAction>();
  private released = new Set<InputAction>();

  // mouse
  mouseX = 0;
  mouseY = 0;
  private mouseDown = false;
  private mousePressed = false;

  constructor(private canvas: HTMLCanvasElement, private gameW = 1280, private gameH = 720) {
    window.addEventListener('keydown', this.onDown);
    window.addEventListener('keyup', this.onUp);
    window.addEventListener('blur', this.onBlur);
    canvas.addEventListener('mousemove', this.onMouseMove);
    canvas.addEventListener('mousedown', this.onMouseDown);
    canvas.addEventListener('mouseup', this.onMouseUp);
    canvas.addEventListener('contextmenu', e => e.preventDefault());
  }

  private onDown = (e: KeyboardEvent) => {
    // не перехватываем клавиши если фокус на поле ввода
    if (document.activeElement instanceof HTMLInputElement) return;
    const action = CODE_MAP[e.code];
    if (!action) return;
    e.preventDefault();
    if (!this.down.has(action)) this.pressed.add(action);
    this.down.add(action);
  };

  private onUp = (e: KeyboardEvent) => {
    if (document.activeElement instanceof HTMLInputElement) return;
    const action = CODE_MAP[e.code];
    if (!action) return;
    e.preventDefault();
    if (this.down.has(action)) this.released.add(action);
    this.down.delete(action);
  };

  private onBlur = () => {
    this.down.clear();
    this.mouseDown = false;
  };

  private onMouseMove = (e: MouseEvent) => {
    const rect = this.canvas.getBoundingClientRect();
    // используем логический размер игры, не физический canvas.width (который * dpr)
    this.mouseX = (e.clientX - rect.left) * (this.gameW / rect.width);
    this.mouseY = (e.clientY - rect.top) * (this.gameH / rect.height);
  };

  private rmbDown = false;
  private rmbPressed = false;

  private onMouseDown = (e: MouseEvent) => {
    if (e.button === 0) {
      if (!this.mouseDown) this.mousePressed = true;
      this.mouseDown = true;
      if (!this.down.has('shoot')) this.pressed.add('shoot');
      this.down.add('shoot');
    }
    if (e.button === 2) {
      if (!this.rmbDown) this.rmbPressed = true;
      this.rmbDown = true;
    }
  };

  private onMouseUp = (e: MouseEvent) => {
    if (e.button === 0) {
      this.mouseDown = false;
      this.down.delete('shoot');
    }
    if (e.button === 2) {
      this.rmbDown = false;
    }
  };

  isDown(action: InputAction): boolean {
    return this.down.has(action);
  }

  wasPressed(action: InputAction): boolean {
    return this.pressed.has(action);
  }

  wasReleased(action: InputAction): boolean {
    return this.released.has(action);
  }

  isMouseDown(): boolean {
    return this.mouseDown;
  }

  wasMousePressed(): boolean {
    return this.mousePressed;
  }

  wasRmbPressed(): boolean {
    return this.rmbPressed;
  }

  endStep(): void {
    this.pressed.clear();
    this.released.clear();
    this.mousePressed = false;
    this.rmbPressed = false;
  }

  clearAll(): void {
    this.down.clear();
    this.pressed.clear();
    this.released.clear();
    this.mouseDown = false;
    this.mousePressed = false;
    this.rmbPressed = false;
  }

  destroy(): void {
    window.removeEventListener('keydown', this.onDown);
    window.removeEventListener('keyup', this.onUp);
    window.removeEventListener('blur', this.onBlur);
    this.canvas.removeEventListener('mousemove', this.onMouseMove);
    this.canvas.removeEventListener('mousedown', this.onMouseDown);
    this.canvas.removeEventListener('mouseup', this.onMouseUp);
  }
}
